import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import { useAuthorizedIntegrationContext } from '@shared/contexts/pluginContexts/AuthorizedIntegrationContext';
import { hasChatsAccess } from '@shared/utils/permissions';

export function useIsChatsLandingAvailable() {
  const { hasVee, isVoomaAdmin, loading } = useMeContext();
  const { authorized: isMailboxAuthorized, loading: isAuthorizationLoading } =
    useAuthorizedIntegrationContext();

  return {
    isAvailable:
      isMailboxAuthorized && hasChatsAccess({ hasVee, isVoomaAdmin }),
    loading: loading || isAuthorizationLoading,
  };
}
